var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-1" }, [
    _c(
      "b",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.Indice,
            expression: "Indice"
          }
        ]
      },
      [_vm._v(_vm._s(_vm.Indice) + ") ")]
    ),
    _vm._v("\n  " + _vm._s(_vm.label) + "\n  "),
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.obrigatorio,
            expression: "obrigatorio"
          }
        ],
        staticClass: "color-error"
      },
      [_vm._v(" *")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5462fbab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5462fbab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/Label/Label.vue
// module id = null
// module chunks = 